import { MenuDto } from './menu.dto';

export class MenuCreateDto extends MenuDto {}
